import React from 'react';
import { Col, FormGroup, Label, Input, Row } from 'reactstrap';

const TemplateName = ({
  name,
  updateTemplateName
}) => {
  return (
    <Col className="section_form_template">
      <h4>Template name</h4>
      <Row>
        <FormGroup>
          <Label for="templateName">name</Label>
          <Input type="text" name="templateName" value={name} onChange={(evt) => updateTemplateName(evt.target.value)} />
        </FormGroup>
      </Row>
    </Col>
  );
};

export default TemplateName;



// WEBPACK FOOTER //
// ./src/components/templates/templateName.js